import { render } from "./EventBus.vue?vue&type=template&id=52351641"
import script from "./EventBus.vue?vue&type=script&lang=js"
export * from "./EventBus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__